export default function sortByDateChat(a, b) {
  const dateA = new Date(a.last_message.created_at);
  const dateB = new Date(b.last_message.created_at);

  return dateB - dateA;
}
